<ion-app>
  <div *ngIf="!isOnline" class="network-status">STAFFY is running in offline mode!</div>
  <div *ngIf="isDemo && showDemoBanner" class="network-status">
    STAFFY is running in Demo mode!
    <a (click)="hideDemoBanner()" class="close-demo">Hide</a>
    <a (click)="exitDemoMode()" class="exit-demo">Exit Demo</a>
  </div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
